import { Helmet } from 'react-helmet';
import ResearchOverview from 'components/Research/ResearchOverview';
import TryEarkick from 'components/Dashboard/TryEarkick';

const Research = ({ canonical }) => {
  return (
    <div className="main-content flex-column research" style={{ background: '#fffef5b' }}>
      <Helmet>
        <link rel="canonical" href={ canonical } />
        <title>Research - Mental Health AI Studies and Publications</title>
        <meta name="description" content="Explore the latest research and studies on AI-powered mental health support. Discover scientific publications and findings related to Earkick's technology." data-react-helmet="true" />
      </Helmet>
      <ResearchOverview />
      <TryEarkick />
    </div>
  );
};

export default Research; 